export default __webpack_public_path__ + "static/speedy6-5a956ee83b95a93c1dd7c1fb0f7b40ac.svg";